import { db } from '@/firebase'

const routeRef = db.collection('routes')

export default {
  state: {
    isRouteBtnLoading: false,
    isRouteDataLoading: false
  },
  mutations: {
    toggleRouteBtnLoading (state, payload) {
      if (payload === undefined || payload === null) {
        state.isRouteBtnLoading = !state.isRouteBtnLoading
      } else {
        state.isRouteBtnLoading = payload
      }
    }
  },
  actions: {
    createRoute ({ commit }, payload) {
      return routeRef.add(payload)
    },
    getRoutes ({ commit }) {
      return routeRef.get()
    },
    getRouteDetail ({ commit }, id) {
      return routeRef.doc(id).get()
    },
    updateStatus ({ commit }, { id, status }) {
      return routeRef.doc(id).update({ status: status })
    },
    /**
     * Actualiza los clientes con todos los datos
     * @param commit
     * @param routeId · ID de la ruta
     * @param clientId · clientId
     * @param productId · productId
     * @param deliveredQuantity · cantidad del producto que se ha entregado
     */
    updateDeliveredProducts ({ commit }, { routeId, clientId, productId, deliveredQuantity }) {
      const item = `clients.${clientId}.deliveredProducts.${productId}`
      return routeRef.doc(routeId)
        .update({ [item]: deliveredQuantity })
    },
    updateDeliveryComments ({ commit }, { routeId, clientId, deliveryComment }) {
      const item = `clients.${clientId}.deliveryComment`
      return routeRef.doc(routeId)
        .update({ [item]: deliveryComment })
    },
    updateDeliveryNote ({ commit }, { routeId, clientId, deliveryNote, paidQuantity, isDeliveryPaid, deliveryStatus }) {
      const path = `clients.${clientId}`
      return routeRef.doc(routeId)
        .update({
          [`${path}.deliveryNote`]: deliveryNote,
          [`${path}.paidQuantity`]: paidQuantity,
          [`${path}.isDeliveryPaid`]: isDeliveryPaid,
          [`${path}.deliveryStatus`]: deliveryStatus
        })
    }
  },
  getters: {
    isRouteBtnLoading: (state) => state.isRouteBtnLoading,
    isRouteDataLoading: (state) => state.isRouteDataLoading
  }
}
